import { View } from "react-native"

export const Divider = () => <View className="flex h-px bg-light-grey m-4 " />
